import { render, staticRenderFns } from "./queryResults.vue?vue&type=template&id=a1321418&scoped=true"
import script from "./queryResults.vue?vue&type=script&lang=js"
export * from "./queryResults.vue?vue&type=script&lang=js"
import style0 from "./queryResults.vue?vue&type=style&index=0&id=a1321418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1321418",
  null
  
)

export default component.exports